import {IMetadataService} from "../services/metadata";
import {L} from "../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {_F} from "../utility/func";
import paragraphise = _F.paragraphise;

interface MetadataComponentBindings {
    layers: Item[];
    activeLayer: Item;
}

export class MultiMetadataComponentController implements ng.IComponentController, MetadataComponentBindings {
    public layers: Item[] = [];
    public activeLayer: Item;
    public _activeLayer: Item;
    public records: Map<number, any> = new Map();
    isOpen = false;

    constructor(protected metadataService: IMetadataService) {
    }

    get title(): string {
        return (this.record && this.record.title)
            || this.layerTitle(this.layer);
    }

    layerTitle(layer: Item) {
        const record = this.records.get(layer.layerId);
        const fromRecords = record && record.title;
        return fromRecords || (layer && layer.name) || ''
    }

    get layer(): Item {
        return this._activeLayer || (this.layers.length && this.layers[0]);
    }

    get record(): any {
        const layer = this._activeLayer || (this.layers.length && this.layers[0]);
        const id = (layer && layer.layerId) || (layer && layer.layerService && layer.layerService.id);
        return this.records.get(id);
    }

    $onChanges(onChangesObj: ng.IOnChangesObject): void {
        if (onChangesObj.layers) {
            const layers = onChangesObj.layers.currentValue as Item[];
            layers.filter(layer => !this.records.has(layer.layerService.id))
                .forEach(layer => {
                    if (layer && layer.isCustom) {
                        this.record.set(layer.layerId, {
                            title: layer.name,
                            description: paragraphise(layer.layerService.longDescription),
                            externalLink: null
                        });
                    } else {
                        const id = (layer && layer.layerId) || (layer && layer.layerService && layer.layerService.id);
                        this.metadataService.getMetadata([layer]).then(result => {
                            this.records.set(id, result[0]);
                        });
                    }
                });

            if (this._activeLayer && !layers.includes(this._activeLayer)) {
                this._activeLayer = null;
            }
        }

        if (onChangesObj.activeLayer) {
            this._activeLayer = onChangesObj.activeLayer.currentValue
                || (this.layers && this.layers.length ? this.layers[0] : null);
        }

        if (onChangesObj.isOpen) {
            this.iconStyle = {
                transform: this.isOpen ? undefined : 'rotate(-0.25turn)',
                transition: '0.25s linear'
            };
        }
    }

    activate(layer: Item) {
        this._activeLayer = layer;
    }

    /*isContext() {
        return this.layer && this.layer.layerType === 'CONTEXT';
    }*/

    iconStyle = {
        transform: this.isOpen ? undefined : 'rotate(-0.25turn)',
        transition: '0.25s linear'
    }
}

export class MultiMetadataComponent implements ng.IComponentOptions {
    controller = ['metadataService', MultiMetadataComponentController];
    bindings = {
        layers: '<',
        activeLayer: '<',
        onChangeActiveLayer: '&',
        lrisQueryStr: '<'
    };
    template =
    `
    <div class="metadata-header" uib-dropdown is-open="$ctrl.isOpen">
        <div class="d-flex flex-1">
            <h4>
                {{ $ctrl.title }}
            </h4>
            &nbsp;
            <button class="div-like" uib-dropdown-toggle ng-disabled="$ctrl.layers.length <= 1">
                <i class="icon icon-dropdown-open" ng-show="$ctrl.layers.length > 1""></i>
            </button>
        </div>

        <ul class="dropdown-menu">
            <li ng-repeat="layer in $ctrl.layers" class="metadata-menu-item" ng-class="{ active: layer == $ctrl.activeLayer }">
                <button class="metadata-menu-button" ng-click="$ctrl.onChangeActiveLayer({layer: layer})">{{ $ctrl.layerTitle(layer) }}</button>
            </li>
        </ul>

        <div class="hidden-sm hidden-xs text-right" ng-if="$ctrl.record && $ctrl.record.externalLink">
            <a ng-href="{{ $ctrl.record.externalLink + '?' + $ctrl.lrisQueryStr() }}" target="_blank" class="obtain-data btn-rounded">Obtain Data</a>
        </div>
    </div>

    <p ng-if="$ctrl.record">
        <span ng-bind-html="$ctrl.record.description"></span>
    </p>`;
}
